export default __webpack_public_path__ + "static/media/img_muslinTwo_yg_p.264ac1f2.jpg";